"use strict";

var _interopRequireDefault = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/objectSpread2.js"));
require("core-js/modules/es.array.find.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.find.js");
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.object.to-string.js");
var _auth = require("@/utils/auth");
var _default2 = exports.default = {
  name: 'wl-dialog-import-record',
  /* 混入 */
  // mixins,
  // components: { fileView, fileFullImage },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    width: {
      type: [String, Number],
      default: '1000px'
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    btnOptions: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    dialogOptions: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    listOptions: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    tableOptions: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    query: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    columns: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    operations: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    rowOperations: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    'bill-code': {
      type: String,
      default: ''
    },
    'import-record-url': {
      type: String,
      default: '/system/import-result/list'
    },
    'download-template-request': {
      type: Function,
      default: function _default() {}
    }
  },
  data: function data() {
    var _this = this;
    return {
      visible: false,
      listDefaultOptions: {
        dataSource: {
          method: 'POST'
        },
        columns: [{
          label: '导入状态',
          code: 'importStatus',
          width: 80,
          formatter: function formatter(r, c, v) {
            var _this$$$getDict;
            return (_this$$$getDict = _this.$$getDict('business_import_status')) === null || _this$$$getDict === void 0 || (_this$$$getDict = _this$$$getDict.find(function (dict) {
              return dict.value === v;
            })) === null || _this$$$getDict === void 0 ? void 0 : _this$$$getDict.label;
          }
        }, {
          label: '导入结果',
          code: 'importResult',
          width: 80
        }, {
          label: '业务编码',
          code: 'billCode',
          width: 120
        }, {
          label: '导入数据',
          code: 'importData'
        }, {
          label: '导入人',
          code: 'createByName',
          width: 90
        }, {
          label: '导入时间',
          code: 'createTime',
          width: 160
        }]
      }
    };
  },
  computed: {
    getListOptions: function getListOptions() {
      var options = this.$$deepMerge(this.listOptions, {
        tableOptions: this.tableOptions,
        query: this.query,
        columns: this.columns,
        operations: this.operations,
        rowOperations: this.rowOperations
      }, this.$$deepMerge(this.listDefaultOptions, this.listOptions));
      if (this.billCode) {
        this.$$deepMerge(this.listOptions.dataSource, {
          data: (0, _objectSpread2.default)({
            conditionLink: 'AND',
            conditions: [{
              column: 'bill_code',
              exp: '=',
              value: this.billCode
            }]
          }, this.listOptions.dataSource.data)
        });
        // this.listOptions.dataSource.data = this.billCode
      }
      if (this.importRecordUrl) this.listOptions.dataSource.url = this.importRecordUrl;
      return options;
    }
  },
  watch: {
    open: {
      handler: function handler(nv) {
        this.visible = nv;
      },
      immediate: true
    },
    visible: {
      handler: function handler(nv) {
        this.$emit('update:open', nv);
      }
    }
  },
  methods: {},
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {}
};